import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LastPageService {
  private lastVisitedPages: { [key: string]: string } = {};

  constructor() {}

  getLastVisitedPage(menuItem: string): string | undefined {
    return this.lastVisitedPages[menuItem];
  }

  setLastVisitedPage(menuItem: string, pageUrl: string) {
    this.lastVisitedPages[menuItem] = pageUrl;
  }
  resetData() {
    this.lastVisitedPages = {};
  }
}
